<template>
  <div style="height:100%;display:grid;align-items:center;">
    <div style="display:grid;align-items:center;height:100%;">
      <div
        class="mx-auto"
        style="display:grid;align-items:center;justify-items:center;"
      >
        <img
          :src="logoSrc"
          style="width: 10rem; height: 10rem;"
          class="mb-7 mt-4"
        />
        <div
          v-if="is_btn_loading"
          class="mt-3 mb-4"
          style="align-items:center;justify-items:center;display:grid;align-items:center;width:100%;height:10rem;width: 20rem;"
        >
          <v-progress-circular color="primary" :size="180" indeterminate>
            <sabira_icon icon="hacker" :width="70" :height="70" />
          </v-progress-circular>
        </div>
        <div style="text-align:center;display:grid;align-items:center;" v-else>
          <div
            v-if="$vuetify.breakpoint.mobile"
            class="mx-auto mt-4"
            style="display:grid;align-items:center;justify-items:center;grid-row-gap:3rem;"
          >
            <sabira_icon icon="hacker" :width="70" :height="70" />
            <span class="subtitle"
              >SABIRA je trenutno dostupna za korištenje isključivo putem laptop
              i desktop uređaja.</span
            >
          </div>
          <div v-else>
            <form @submit.prevent="login">
              <v-text-field
                v-model="user.username"
                :label="$t('username')"
                placeholder=" "
                style="width: 20rem"
                clearable
                clear-icon="mdi-close"
                class="mt-2 mb-4"
                persistent-hint
                hide-details
                outlined
                prepend-inner-icon="mdi-account-outline"
                @keyup.enter="login"
                autocomplete="username"
              ></v-text-field>

              <v-text-field
                v-model="user.password"
                :label="$t('password')"
                placeholder=" "
                style="width: 20rem"
                clear-icon="mdi-close"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                class="mt-4 mb-2"
                persistent-hint
                hide-details
                outlined
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @keyup.enter="login"
                autocomplete="current-password"
              ></v-text-field>
            </form>
            <div style="text-align: left;color:#195391;margin-top: 0;">
              <v-btn plain text small class="ma-0" @click="show_password_email"
                >Lozinka?</v-btn
              >
            </div>
            <v-btn :loading="is_btn_loading" color="primary" @click="login">
              <span class="elevation-0">{{ $t("login") }}</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div style="text-align:center;display:grid;">
        <div class="text-caption">
          &copy; SABIRA™
          {{ new Date().getFullYear() }}
        </div>
        <div class="text-caption" style="opacity: 0.70;">
          Sva prava zadržana. Reprodukcija u cijelosti ili dijelom, u bilo
          kakvoj formi ili mediju, bez izričite pismene <br />dozvole od strane
          <a
            href="https://www.webpage.ba"
            target="_blank"
            style="text-decoration:none;color:inherit"
            >DSO WEBPAGE.ba</a
          >
          je strogo zabranjena. Za više informacija posjetite
        </div>
        <div class="mt-4">
          <a
            href="https://sabira.ba"
            target="_blank"
            style="text-decoration:none;"
            >www.sabira.ba</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoSrc from "@/assets/images/sabira_logo_full.svg";
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
  },
  name: "Login",
  data() {
    return {
      logoSrc,
      showPassword: false,
      is_btn_loading: false,
      validation_errors: [],
      window: 0,
      loading: false,
      error_message: null,
      snackbar: false,
      remember_me: false,
      user: {
        password: "",
        username: "",
        id: null,
        locale: null,
        active: true,
      },
      postBody: "",
      language: "",
      show_languages: false,
      known_user: false,
      error: false,
    };
  },
  methods: {
    show_password_email() {
      this.$webpageEventBus.$emit("show_password_email");
    },
    validate() {
      this.validation_errors = [];

      if (
        typeof this.user.username == "undefined" ||
        this.user.username == null ||
        this.user.username.length == 0
      ) {
        this.validation_errors.push({
          id: 0,
          text: this.$t("credentials_missing"),
        });
      }

      if (
        typeof this.user.password == "undefined" ||
        this.user.password == null ||
        this.user.password.length == 0
      ) {
        this.validation_errors.push({
          id: 1,
          text: this.$t("error_password_missing"),
        });
      }
      return this.validation_errors.length == 0;
    },
    new_user() {
      if (this.local_users !== null) {
        this.window = 1;
      } else {
        this.window = 2;
      }
    },
    login() {
      if (this.validate()) {
        this.is_btn_loading = true;
        this.$http({
          method: "POST",
          url: "/auth/login",
          withCredentials: false,
          data: {
            username: this.user.username,
            password: this.user.password,
          },
        })
          .then((resp) => {
            if (resp.status == 200) {
              if (resp.data !== null) {
                if (resp.data.active) {
                  this.user = resp.data;
                  this.$helpers
                    .load_user_profile(resp.data.id)
                    .then(() => {
                      this.$webpageEventBus.$emit("show_status", {
                        message: "Dobrodošli " + this.$store.getters.user.name,
                        type: "primary",
                        timeout: 3000,
                      });
                      this.$router.push("/start");
                    })
                    .catch((user_err) => {
                      this.$webpageEventBus.$emit("show_status", {
                        message: user_err.message,
                        type: "error",
                        timeout: 3000,
                      });
                      this.$router.push("/login");
                    });
                } else {
                  this.$webpageEventBus.$emit("show_status", {
                    message: this.$t("deactivated"),
                    type: "error",
                    timeout: 3000,
                  });
                }
              } else {
                this.$webpageEventBus.$emit("show_status", {
                  message: this.$t("authorization_failed"),
                  type: "error",
                  timeout: 3000,
                });
                this.is_btn_loading = false;
              }
            } else {
              if (resp.status == 204) {
                this.$webpageEventBus.$emit("show_status", {
                  message: this.$t("authorization_failed"),
                  type: "error",
                  timeout: 3000,
                });
                this.is_btn_loading = false;
              } else {
                this.$webpageEventBus.$emit("show_status", {
                  message: resp.data.message,
                  type: "error",
                  timeout: 3000,
                });
              }
            }
          })
          .catch((err) => {
            this.$webpageEventBus.$emit("show_status", {
              message: err.message,
              type: "error",
              timeout: 3000,
            });
            this.is_btn_loading = false;
          });
      } else {
        this.$webpageEventBus.$emit("show_status", {
          message: this.validation_errors[0].text,
          type: "error",
          timeout: 3000,
        });
        this.is_btn_loading = false;
      }
    },
    switch_language(language) {
      this.$i18n.locale = language;
      this.language = language;
      this.show_languages = false;
      this.$moment.locale(this.$i18n.locale);
    },
    switch_user(user) {
      this.user = user;
      this.window = 0;
      this.user.password = null;
    },
    add_user() {
      this.user.username = null;
      this.user.password = null;
      this.window = 2;
    },
    get_active_locale_name() {
      return "hr";
    },
    add_user_to_local_store() {
      var users = JSON.parse(localStorage.getItem("users"));
      if (users === null) {
        users = [];
        users.push({
          id: this.$store.getters.user.id,
          username: this.$store.getters.user.username,
          account_id: this.$store.getters.user.account_id,
          name: this.$store.getters.user.name,
          starting_number: this.$store.getters.user.starting_number,
          invoice_pattern: this.$store.getters.user.invoice_pattern,
          offer_starting_number: this.$store.getters.user.offer_starting_number,
          ko_starting_number: this.$store.getters.user.ko_starting_number,
          auto_stamp: this.$store.getters.user.auto_stamp,
          auto_signature: this.$store.getters.user.auto_signature,
        });
        localStorage.setItem("users", JSON.stringify(users));
      } else {
        if (users.filter((e) => e.username == this.user.username).length > 0) {
          var current_user = users.filter(
            (e) => e.username == this.user.username
          )[0];
          current_user.locale = this.$i18n.locale;
          localStorage.setItem("users", JSON.stringify(users));
        } else {
          users.push({
            id: this.$store.getters.user.id,
            username: this.$store.getters.user.username,
            name: this.$store.getters.user.name,
            account_id: this.$store.getters.user.account_id,
            starting_number: this.$store.getters.user.starting_number,
            invoice_pattern: this.$store.getters.user.invoice_pattern,
            offer_starting_number: this.$store.getters.user
              .offer_starting_number,
            ko_starting_number: this.$store.getters.user.ko_starting_number,
            auto_stamp: this.$store.getters.user.auto_stamp,
            auto_signature: this.$store.getters.user.auto_signature,
          });
          localStorage.setItem("users", JSON.stringify(users));
        }
      }
    },
    store_cookie() {
      this.$cookies.set("username", this.$store.getters.user.username);
    },
  },
  computed: {
    local_users() {
      var stored_users = JSON.parse(localStorage.getItem("users"));
      if (stored_users !== null) {
        return stored_users;
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.is_btn_loading = false;
    if (localStorage.getItem("darkMode")) {
      this.darkMode = JSON.parse(localStorage.getItem("darkMode"));
      this.$vuetify.theme.dark = this.darkMode;
    }
  },
};
</script>

<style scoped>
.loginBlock {
  background-color: rgba(255, 255, 255, 0) !important;
  border-color: white !important;
  position: absolute;
  top: 25vh;
  right: 10%;
}

.sabiraBlock {
  background-color: rgba(255, 255, 255, 0) !important;
  position: absolute;
  top: 13vh;
  right: 10%;
}
</style>
